import styled from 'styled-components'
import { device } from '../../../utils/helpers'

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${props => props.width};
  padding: ${props => props.padding};
`

export const Label = styled.label`
  font-family: 'BarlowSemiBold';
  font-size: 1em;
  text-transform: uppercase;
  margin-bottom: 8px;

  @media ${device.tablet} {
    font-size: 0.9375vw;
    margin-bottom: 0.4166666666666667vw;
  }

  ${'' /* @media ${device.laptopL} {
    font-size: 1em;
  }

  @media ${device.desktop} {
    font-size: 1em;
  } */}
`

export const ErrorText = styled.div`
  color: red;
  font-size: 0.8em;
`

export const FormGroup = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: ${props => props.margin};
`



// WEBPACK FOOTER //
// ./src/components/UI/Form/Common.js